/*
 *
 * AllottedCasesDetailsPage actions
 *
 */

import { CASEDETAILS, DEFAULT_ACTION, SET_RERENDER } from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION
  };
}

export function caseDetails(payload) {
  return {
    type: CASEDETAILS,
    payload: payload
  };
}
export const setApiReRender = (value) => ({
  type: SET_RERENDER,
  payload: value,
});
